import type { DeviationJustificationDataProps, DeviationJustificationFormProps } from './types'

export const setInitialValues = (data: DeviationJustificationDataProps): DeviationJustificationFormProps => {
  return {
    economicGroup: data.economicGroup || '',
    profitCenter: data.profitCenter || '',
    account: data.account || '',
    budget: data.budget?.toFixed(2) || '0.00',
    actualPreview: data.actualPreview?.toFixed(2) || '0.00',
    deviationVsBudget: data.deviationVsBudget?.toFixed(2) || '0.00',
    deviationVsBudgetPercentage: data.deviationVsBudgetPercentage?.toFixed(2) || '0.00',
    deviationTypeBudget: data.deviationTypeBudget || '',
    observationsBudget: data.observationsBudget || '',
    previewWeek: data.previewWeek?.toFixed(2) || '0.00',
    actualPreviewWeek: data.actualPreviewWeek?.toFixed(2) || '0.00',
    deviationVsPreviewWeek: data.deviationVsPreviewWeek?.toFixed(2) || '0.00',
    deviationVsPreviewWeekPercentage: data.deviationVsPreviewWeekPercentage?.toFixed(2) || '0.00',
    deviationTypeWeek: data.deviationTypeWeek || '',
    observationsWeek: data.observationsWeek || ''
  }
}
